<div class="card">
    <div class="card-body">
      <h3 class="card-title">Access Denied</h3>
      <div class="text-center">
        <img src="./assets/img/access-denied.png" alt="" height="100" class="d-inline-block align-text-top">
      </div>
      <br/>
      <p>Error Code: {{error_code}}</p>
      <div [ngSwitch]="error_code">
        <div *ngSwitchCase="'SU-001'">
            <p>Reason: Unauthorized</p>
            <p>Please contact your Quantexa account manager to resolve, ensuring to quote the above error code.</p>
        </div>
        <div *ngSwitchCase="'SU-002'">
            <p>Reason: Not Verified</p>
            <p>Please verify your email to resolve. Check your inbox including junk/spam.</p>
            <p>If you have not received the verification email, please contact your Quantexa account manager to resolve.</p>
        </div>
        <div *ngSwitchCase="'SU-003'">
            <p>Reason: Not Authorized</p>
            <p>Please contact your Quantexa account manager to request access.</p>
        </div>
        <div *ngSwitchDefault>
            <p>Reason: Unspecified</p>
            <p>Please contact your Quantexa account manager to resolve, ensuring to quote the above error code.</p>
        </div>
      </div>
    </div>
</div>
